import React, { Fragment } from 'react';
import EventoCard from './EventoCard';

export default function EventosRelacionados({ eventos }) {
    if (!eventos || eventos.length === 0) return null;

    return (
        <Fragment>
            <section className="event-section" style={{paddingTop: "40px", paddingBottom: "60px"}}>
                <div className="section-header-3">
                    <span className="cate">También te puede interesar</span>
                    <h2 className="title">Otros Eventos</h2>
                </div>
                <div className="container" style={{maxWidth: "100%"}}>
                    <div className="row mb-10 justify-content-center">
                        {eventos.map(evento => (
                            <EventoCard key={evento.id} evento={evento} />
                        ))}
                    </div>
                </div>
            </section>
        </Fragment>
    );
}
